customElements.get('gochi-nutrition-panel') ||
  customElements.define('gochi-nutrition-panel', class extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('.gochi-nutrition-panel__tab'));
      this.panels = Array.from(this.querySelectorAll('[data-flavor-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.flavor));
      });
    }

    select(flavor) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.flavor === flavor;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.flavorPanel !== flavor;
      });
    }
  });
